import { CurrencyPipe, DatePipe, DecimalPipe } from "@angular/common";
import { Component } from "@angular/core";
//services

import { PaquetesAdquiridosService } from "src/app/core/services/paquetes-adquiridos.service";
@Component({
  selector: "app-mis-paquetes",
  standalone: true,
  imports: [CurrencyPipe, DatePipe, DecimalPipe],
  templateUrl: "./mis-paquetes.component.html",
  styleUrl: "../../../app.component.scss",
})
export class MisPaquetesComponent {
  currentUser: any;
  listadoPaquetes: any;
  userLocal: boolean = true;

  constructor(private __paquetesAdquiridosService: PaquetesAdquiridosService) {}

  ngOnInit(): void {
    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.currentUser = JSON.parse(currentUser);
      this.userLocal = JSON.parse(currentUser).local;
    }
    this.getPaquetesByPaciente(this.currentUser.userId);
  }

  /**
   *
   * @param idPaciente
   */
  getPaquetesByPaciente(idPaciente: string) {
    this.__paquetesAdquiridosService
      .getDataByPaciente(idPaciente)
      .then((paquetes: any) => {
        this.listadoPaquetes = paquetes;
        console.log("paquetes", paquetes);
      });
  }

  /**
   *
   * @param date
   * @returns
   */
  convertToLocal(date: string | Date): Date {
    const utcDate = new Date(date);
    const localDate = new Date(utcDate.getTime() - -5 * 60 * 60 * 1000); // UTC-5
    return localDate;
  }
}
